// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1k-q";
export var animationRelative = "_1k-p";
export var backdropBlur = "_1k-0";
export var detailLabelCell = "_1k-12";
export var detailTable = "_1k-11";
export var detailValueCell = "_1k-13";
export var docIconBox = "_1k-1d";
export var docIconBoxMd = "_1k-1f";
export var docIconBoxSm = "_1k-1e";
export var docTypeRow = "_1k-16";
export var docTypeRowInner = "_1k-17";
export var dropdownMatchDatePicker = "_1k-3";
export var evidenceCardContent = "_1k-1c";
export var fileUploadSpin = "_1k-j";
export var gorgiasOpenButton = "_1k-15 _1k-d";
export var gorgiasTicketCard = "_1k-14";
export var heroModalFooterButton = "_1k-18";
export var hiddenContainer = "_1k-o";
export var iconPrimary = "_1k-1g";
export var iconSecondary = "_1k-1h";
export var iconTertiary = "_1k-1i";
export var integrationCard = "_1k-1";
export var integrationLogoBox = "_1k-2";
export var mainColumnSticky = "_1k-1b";
export var maxWidthContainer = "_1k-19";
export var modalContentBody = "_1k-a";
export var modalHeaderImage = "_1k-5";
export var modalImageLabel = "_1k-7";
export var modalImageOverlay = "_1k-6";
export var modalImageSubtitle = "_1k-9";
export var modalImageTitle = "_1k-8";
export var modalImageWrapper = "_1k-4";
export var modalStickyFooter = "_1k-b";
export var removeButton = "_1k-e";
export var sidebarColumn = "_1k-1a";
export var spinner = "_1k-i";
export var timelineLine = "_1k-y";
export var timelineLineBlack = "_1k-10 _1k-y";
export var timelineLineGray = "_1k-z _1k-y";
export var timelineLineHeight = "_1k-x";
export var tlDotActivate = "_1k-u";
export var tlDotActivateAnim = "_1k-t";
export var tlDotHide = "_1k-s";
export var tlDotHideAnim = "_1k-r";
export var tlLineActivate = "_1k-w";
export var tlLineActivateAnim = "_1k-v";
export var uploadHint = "_1k-n";
export var uploadIconBox = "_1k-k";
export var uploadLabel = "_1k-m";
export var uploadText = "_1k-l";
export var uploadZone = "_1k-f";
export var uploadZoneCursorDefault = "_1k-h";
export var uploadZoneCursorPointer = "_1k-g";
export var uploadedFileRow = "_1k-c";
export var viewButton = "_1k-d";